import './mdl-progress';
import './mdl-spinner';
import './pacman';



// WEBPACK FOOTER //
// ./src/spinner/index.js